<div class="file-upload">
  <a-button @click="showModal">
    <ant-icon type="UploadOutlined"></ant-icon>
    <span>{{ uploadButtonText }}</span>
  </a-button>

  <div class="file-list">
    <div v-for="item in fileList" :key="item.uuid" class="file-list__item">
      <div class="file-list__item__icon">
        <ant-icon type="PaperClipOutlined"></ant-icon>
      </div>
      <a :href="item.url" :title="item.name" target="_blank">
        <span>{{ item.name }}</span>
      </a>
      <div class="file-list__item__action">
        <ant-icon type="DeleteOutlined"></ant-icon>
      </div>
    </div>
  </div>

  <a-modal
    v-model:visible="visible"
    :centered="true"
    :confirm-loading="uploading"
    :keyboard="false"
    :mask-closable="false"
    width="960px"
    @cancel="closeModal"
    :zIndex="1100"
    @ok="ok"
  >
    <template #title>
      <span>附件上传</span>
      <small>附件上限{{ maxCount }}个，单个文件不得超过{{ maxSize }}M</small>
    </template>

    <hmd-table-action class="pt0">
      <template #left>
        <a-upload
          :before-upload="beforeUpload"
          :custom-request="customRequest"
          :multiple="true"
          :show-upload-list="false"
          name="file"
        >
          <a-button :disabled="disabled" :loading="uploading" type="primary">
            {{ uploadButtonText }}
          </a-button>
          <span class="text-grey ml15">（已选择{{ fileList.length }}个文件）</span>
        </a-upload>
      </template>
    </hmd-table-action>

    <a-table
      :bordered="true"
      :columns="columns"
      :data-source="fileList"
      :pagination="false"
      :scroll="{ x: true }"
      row-key="uid"
    >
      <template #size="{ record }">
        <span>{{ $filters.humanizeFileSize(record.size) }}</span>
      </template>
      <template #status="{ record }">
        <file-status :status="record.status"></file-status>
      </template>
      <template #action="{ record }">
        <hmd-empty-link
          v-if="['SUCCESS','FAIL'].includes(record.status)"
          @click="deleteFile(record)"
        >
          删除
        </hmd-empty-link>
      </template>
    </a-table>
  </a-modal>
</div>
